export const DIFFICULTY_DESCRIPTIONS = {
  easy: 'zero downtime, zero performance risks',
  medium: 'zero downtime, potential performance trade-offs',
  hard: 'downtime required, potential performance trade-offs'
};
